import React from "react";
import styled, { keyframes } from "styled-components";

import { userTrack } from "../Common";
import { BlackBtn } from "../IPWebsiteRedesign/BlackBtn";
import ArrowLeft from "../IPWebsiteRedesign/images/ArrowLeft.svg";
import Image from "next/image";
import getConfig from "next/config";
const MainBanner = styled.div`
  overflow-x: hidden;
`;
const BannerBg = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  /* height: 580px; */
  min-height: 580px;
  margin: 0 auto;
  padding-top: 120px;
  background: url(${(props) => props.dImage});
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: -10px;
  position: relative;
  @media (min-width: 1524px) and (max-width: 1920px) {
    /* height: 562px; */
  }
  @media screen and (max-width: 767px) {
    /* height: ${(props) =>
      props.alt === "Terms of Service" ? "446px" : "530px"} !important; */
    min-height: auto;
    background: #fff2e3 !important;
  }
  @media only screen and (max-width: 414px) {
    /* height: 410px; */
    min-height: auto;
  }
  @media only screen and (max-width: 375px) {
    /* height: 440px; */
    min-height: auto;
  }
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (stroke-color: transparent) {
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    /* height: 100%; */
    min-height: auto;
    padding-bottom: 50px;
  }
`;
const BannerTitle = styled.p`
  font-family: Roboto;
  font-size: 60px;
  font-weight: 400;
  line-height: 76px;
  letter-spacing: -1.2157880067825317px;
  margin: 0;
  color: #000000;
  text-align: center;
  font-family: Roboto;
  margin-bottom: 30px;
  text-align: center;

  @media screen and (max-width: 767px) {
    margin: 0 auto;
    font-size: 31px;
    margin-bottom: 30px;
    width: 340px;
    line-height: 40px;
  }

  @media only screen and (max-width: 375px) {
    margin-top: 0px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 35px;
    line-height: 51px;
  }
`;

const BannerSmallTitle = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height: 49px;
  text-align: center;
  color: #ff7624;
  text-align: center;
  font-family: Roboto;
  text-align: center;
  margin-bottom: 0;

  @media screen and (max-width: 767px) {
    margin: 0 auto;
    font-size: 20px;
    width: 340px;
  }

  @media only screen and (max-width: 375px) {
    margin-top: 0px;
  }
`;

const BannerDesc = styled.p`
  font-size: 20px;
  line-height: 29px;
  margin: 0 auto;
  color: #515151;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0.8px;
  text-align: center;
  width: 700px;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    width: auto;
    padding: 0 10px;
  }
`;

const BannerDesc1 = styled.p`
  font-size: 20px;
  margin: 0 auto;
  color: #515151;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.8px;
  margin-bottom: 25px;
  line-height: 35px;

  @media (min-width: 320px) and (max-width: 480px) {
    line-height: 34px;
    margin-bottom: 16px;
    text-wrap-style: balance;
  }
`;
const Wrapper = styled.div`
  width: 836px;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 20px;
  }
`;
const BtnWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 75px;

  @media screen and (max-width: 767px) {
    margin-bottom: 50px;
    gap: 0;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 30px;
    gap: 0;
  }
`;
const Wrap = styled.div`
  margin: 0 auto;
  margin-top: 50px;
  width: 790px;
  /* position: absolute; */

  position: relative; 
  display: flex;
  flex-direction: column; 

  @media screen and (max-width: 767px) {
    width: 100%;
  }
  /* @media only screen and (max-width: 414px) {
    top: 42%;
  }
  @media only screen and (max-width: 375px) {
    top: 45%;
  } */

  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (stroke-color: transparent) {
      transform: translate(-50%, -65%);
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 10px;
  }
`;
const TxtWrap = styled.div`
  width: 790px;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const ArrowWrapper = styled.div`
  position: relative;
`;

const moveArrow = keyframes`
  0%, 100% {
    right: -400px;
  }
  50% {
    right: -350px;
  }
`;

const Img = styled.div`
  position: absolute;
  right: -400px;
  top: -100px;
  animation: ${moveArrow} 1s ease-in-out infinite;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export default function CommonBanner(props) {
  const { publicRuntimeConfig } = getConfig();

  // const HandleFreeTrail = async () => {
  //   await userTrack("", "Onclick of Get started for free", "Platform");
  //   window.location.href =
  //     process.env.NODE_ENV == "development"
  //       ? "/Get-Started"
  //       : publicRuntimeConfig.assetPrefix + "/Get-Started.html";
  // };


  const HandleFreeTrail = async () => {
    await userTrack("", "Onclick of Schedule a demo", "Platform");

    // Dynamically construct the UTM source
    const pageName = `${window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop()
      .toLowerCase()
      .replace(/\s+/g, "-")}-page`;
    const buttonName = "schedule-demo-button"; 

    // Format titleName: lowercase and replace spaces with hyphens
    const titleName = document.title.toLowerCase().replace(/\s+/g, "-");

    const utmSource = `${pageName}-${buttonName}-${titleName}`;
    const encodedUtmSource = window.btoa(utmSource); // Encode the UTM source

    // Store encoded UTM source in localStorage
    localStorage.setItem("utm-source", encodedUtmSource);
    window.location.href =
      process.env.NODE_ENV == "development"
        ? "/Schedule-Demo"
        : publicRuntimeConfig.assetPrefix + "/Schedule-Demo.html";
  };



  return (
    <MainBanner>
      <BannerBg alt={props.title} dImage={props.dImage.src}>
        <Wrap>
          <Wrapper>
            <BannerSmallTitle>{props.smalltitle}</BannerSmallTitle>
            <TxtWrap>
              <BannerTitle>{props.title}</BannerTitle>
            </TxtWrap>

            <BannerDesc1>{props.desc1}</BannerDesc1>
            <BannerDesc>{props.desc}</BannerDesc>
          </Wrapper>

          <BtnWrap>
            <ArrowWrapper>
              <Img>
                <Image alt="ArrowLeft" src={ArrowLeft} />
              </Img>
            </ArrowWrapper>
            <BlackBtn onClick={HandleFreeTrail}>{"Schedule a demo"}</BlackBtn>
          </BtnWrap>
        </Wrap>
      </BannerBg>
    </MainBanner>
  );
}
